import { useAppSelector, useAppDispatch } from '@/store/hooks';
import { hideError } from '@/store/slices/helpersSlice';

/**
 * 원본: .old-gc-mono/apps/gc-zoku/components/ErrorsModal.js
 * 에러 모달 (Ant Design Modal → 순수 HTML dialog)
 */
function ErrorsModal() {
  const dispatch = useAppDispatch();
  const errors = useAppSelector((s) => s.helpers.errors);
  const isOpen = useAppSelector((s) => s.helpers.errorsModalIsOpen);

  const error = errors[errors.length - 1];

  if (!error || !isOpen) return null;

  return (
    <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black/50">
      <div className="bg-white rounded-lg shadow-xl w-[80%] max-w-lg">
        <div className="flex items-center justify-between px-6 py-4 border-b">
          <h3 className="text-lg font-semibold text-red-600">Error</h3>
          <button
            onClick={() => dispatch(hideError())}
            className="text-gray-400 hover:text-gray-600 text-xl leading-none"
          >
            &times;
          </button>
        </div>
        <div className="px-6 py-4">
          <div className="flex items-start gap-3 p-4 bg-red-50 border border-red-200 rounded">
            <i className="fa fa-exclamation-circle text-red-500 mt-0.5" />
            <span className="text-red-700">{error.message}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ErrorsModal;
